import { useMutation } from '@tanstack/react-query';

import { handleError } from '../../../../utils/admin';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { postCreateRootDocument } from '../../requests/postCreateRootDocument';

type CreateRootDocumentPayload = {
  definitionName: string;
  workflowName: string;
};

export const useCreateRootDocument = () => {
  const { constructPost } = useRequestConstructor();

  const { mutateAsync: createRootDocument, ...rest } = useMutation({
    mutationFn: ({ definitionName, workflowName }: CreateRootDocumentPayload) =>
      postCreateRootDocument(constructPost, definitionName, workflowName),
    onError: () => handleError('Could not start deal.'),
  });

  return { createRootDocument, ...rest };
};
